export default [
  { timeOfDay: 6, deathPerHour: 0.477777778 },
  { timeOfDay: 7, deathPerHour: 0.611111111 },
  { timeOfDay: 8, deathPerHour: 0.466666667 },
  { timeOfDay: 9, deathPerHour: 0.322222222 },
  { timeOfDay: 10, deathPerHour: 0.366666667 },
  { timeOfDay: 11, deathPerHour: 0.377777778 },
  { timeOfDay: 12, deathPerHour: 0.388888889 },
  { timeOfDay: 13, deathPerHour: 0.333333333 },
  { timeOfDay: 14, deathPerHour: 0.377777778 },
  { timeOfDay: 15, deathPerHour: 0.288888889 },
  { timeOfDay: 16, deathPerHour: 0.433333333 },
  { timeOfDay: 17, deathPerHour: 0.588888889 },
  { timeOfDay: 18, deathPerHour: 0.533333333 },
  { timeOfDay: 19, deathPerHour: 0.522222222 },
  { timeOfDay: 20, deathPerHour: 0.7 },
  { timeOfDay: 21, deathPerHour: 0.788888889 },
  { timeOfDay: 22, deathPerHour: 0.988888889 },
  { timeOfDay: 23, deathPerHour: 0.911111111 },
  { timeOfDay: 24, deathPerHour: 0.788888889 },
  { timeOfDay: 25, deathPerHour: 0.822222222 },
  { timeOfDay: 26, deathPerHour: 0.855555556 },
  { timeOfDay: 27, deathPerHour: 0.566666667 },
  { timeOfDay: 28, deathPerHour: 0.611111111 },
  { timeOfDay: 29, deathPerHour: 0.5 },
  { timeOfDay: 30, deathPerHour: 0.477777778 },
];
